import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Banco de Evaluaciones y Rúbricas de Metodología',
  value: '15',
  desc: 'Evaluaciones listas con distintos niveles de dificultad y rúbricas alineadas a los temas del pack. Nunca más construyas un examen desde cero bajo presión.',
  benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.'
}, {
  id: '02',
  title: 'Glosario Completo de Términos de Metodología de la Investigación',
  value: '12',
  desc: 'Un glosario claro y completo con todos los términos clave de metodología de la investigación, listo para entregar directamente a tus alumnos.',
  benefit: 'Nunca más pierdas tiempo de clase explicando qué significa cada concepto desde cero.'
}, {
  id: '03',
  title: 'Manual de Respuestas para Preguntas Difíciles de Metodología',
  value: '10',
  desc: '¿Qué respondo cuando un alumno pregunta por qué su investigación no puede ser cuantitativa y cualitativa al mismo tiempo? ¿O cuándo preguntan la diferencia real entre técnica e instrumento? Este manual te da la respuesta correcta antes de que el alumno te ponga en aprietos.',
  benefit: 'Nunca más un silencio incómodo frente a una pregunta metodológica inesperada.'
}, {
  id: '04',
  title: 'Mapa Visual del Proceso de Investigación',
  value: '9',
  desc: 'Un esquema visual completo que muestra todo el proceso investigativo de forma ordenada y clara. Proyéctalo en el aula o entrégalo impreso y tus alumnos tendrán una referencia visual permanente durante todo el año.',
  benefit: 'Sin explicaciones extra. Lo ven, lo entienden y lo usan.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-15" data-mp="3c5s9zi2crsb5">
      <div className="max-w-5xl mx-auto" data-id="element-16" data-mp="3h4vacp7e1acs">
        <div className="text-center mb-16" data-id="element-17" data-mp="3h7rckpq9ql71">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18" data-mp="1h2vr4rdbnj0l">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19" data-mp="1c3iz7s7lflr5">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20" data-mp="1q1r02b7r377l">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21" data-mp="ycxbnq772nmx" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22" data-mp="ao4mqdozpg1t">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23" data-mp="5awi8lwehudt">
                <Gift size={24} data-id="element-24" data-mp="3msfqk7oj06t6" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-25" data-mp="3rp61yhpdye89">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26" data-mp="jb7antdczh13">
                <span className="text-gray-400 text-sm" data-id="element-27" data-mp="o98tcd6vhec1">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28" data-mp="9c8188krrhd1">USD {bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29" data-mp="ea9tnk434t16">→ GRATIS</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30" data-mp="2u273q2j1oy89">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31" data-mp="2z1a7zkr7b0f6">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32" data-mp="3ahq3dmtck5xp">
          <p className="text-gray-300 mb-2" data-id="element-33" data-mp="3t7ej48omnfsh">Valor total de los 4 bonos</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34" data-mp="3t63bfxs29nw3">USD 46,00</p>
          <p className="text-lg text-white mb-2" data-id="element-35" data-mp="3o70b2qn105ug">Tu precio hoy</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36" data-mp="3j8qdyahqqv67">
            🎁 GRATIS
          </p>
          <p className="text-sm text-gold-light" data-id="element-37" data-mp="2cuhav7uxhwm7">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" data-mp="27wpjqg23yej2" />
      </div>
    </section>;
}